import { createFileRoute } from '@tanstack/react-router'
import PrinterPriceImport from 'Admin/components/printerprice/PrinterPriceImport'

import { Guard } from '../-guard'

export const Route = createFileRoute('/admin/printerprices')({
    component: () => (
        <Guard claims={['opus_user']}>
            <PrinterPriceImport />
        </Guard>
    ),
})
